export default __webpack_public_path__ + "static/media/ExitIntentCMLogo.a50feefa.svg";